import { gql } from "@apollo/client";

export const ADMIN_NOTIFICATION = gql`
  query getNotificationForAdmin($limit: Int = null, $offset: Int = null) {
    notificationforAdmin(limit: $limit, offset: $offset) {
      allMeetings {
        nodes {
          mId
          mTopic
          mStartTime
          meetingCategoryByMcId
        }
        totalCount
      }
      allCalenders {
        nodes {
          eId
          eDescription
          eTitle
          eOriginalTitle
        }
        totalCount
      }
      allWorkshops {
        nodes {
          wsId
          wsDescription
          wsStartTime
          wsTopic
        }
        totalCount
      }
    }
  }
`;
